import React, {useEffect} from "react";

import styles from "./BulkUpdatePage.module.css";
import {useAppDispatch} from "../../../../app/hooks";
import {MenuItem, updateSelectedMenuItem} from "../../platform/platformSlice";
import {BulkUpdateOptionCard} from "../card/BulkUpdateOptionCard";
import {BULK_UPDATES} from "../bulkUpdateDefinitions";

export const BulkUpdatePage: React.FC = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(updateSelectedMenuItem(MenuItem.BULK_UPDATE));
    }, [dispatch]);

    return <div className={styles.wrapper}>
        <div className={styles.titleWrapper}>
            <span className={styles.title}>Bulk update</span>
            <p className={styles.description}>
                Change many locations at once: download the current data, edit it in Excel or any spreadsheet
                tool, and upload it back.
            </p>
        </div>
        <div className={styles.grid}>
            {BULK_UPDATES.map(definition => <BulkUpdateOptionCard key={definition.key} definition={definition}/>)}
        </div>
    </div>
}
